import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api/client';
import { useAuth } from '../hooks/useAuth';
import { t } from '../hooks/useT';

interface Entry {
  rank: number;
  displayName: string;
  score: number;
  dezoomsUsed: number;
  won: boolean;
  isMe: boolean;
}

export function LeaderboardPage() {
  const { user } = useAuth();
  const [entries, setEntries] = useState<Entry[]>([]);
  const [myRank, setMyRank] = useState<number | null>(null);
  const [myScore, setMyScore] = useState<number | null>(null);
  const [myPlayed, setMyPlayed] = useState(false);
  const [myWon, setMyWon] = useState(false);
  const [playersCount, setPlayersCount] = useState(0);
  const [puzzleNumber, setPuzzleNumber] = useState(0);

  useEffect(() => {
    api<{
      entries: Entry[];
      myRank: number | null;
      myScore: number | null;
      myPlayed: boolean;
      myWon: boolean;
      playersCount: number;
      puzzleNumber: number;
    }>('/leaderboard/today')
      .then((data) => {
        setEntries(data.entries);
        setMyRank(data.myRank);
        setMyScore(data.myScore);
        setMyPlayed(data.myPlayed);
        setMyWon(data.myWon);
        setPlayersCount(data.playersCount);
        setPuzzleNumber(data.puzzleNumber);
      })
      .catch(() => {});
  }, []);

  return (
    <main className="page leaderboard">
      <h1>{t('leaderboard.title')}</h1>
      <p className="sub">Énigme #{puzzleNumber}</p>
      {playersCount > 0 && (
        <p className="lb-players-count">
          {playersCount} {playersCount > 1 ? t('leaderboard.players') : t('leaderboard.player')}
        </p>
      )}
      {user && myPlayed && myWon && myRank != null && (
        <p className="my-rank">{t('leaderboard.myRank')} #{myRank}</p>
      )}
      {user && myPlayed && !myWon && (
        <p className="my-rank my-rank--lost">
          {t('leaderboard.myPlayed')} — {myScore ?? 0} pt
        </p>
      )}
      <ol className="lb-list">
        {entries.map((e) => (
          <li key={`${e.rank}-${e.displayName}`} className={`${e.isMe ? 'me' : ''}${!e.won ? ' lost' : ''}`}>
            <span className="rank">#{e.rank}</span>
            <span className="name">{e.displayName}</span>
            <span className="pts">{e.score}</span>
          </li>
        ))}
      </ol>
      {!entries.length && <p className="muted">{t('leaderboard.empty')}</p>}
      <Link to="/play" className="btn primary">{t('profile.playToday')}</Link>
    </main>
  );
}
